import { classMerge } from '@components/utilities/classMerge'

interface CarouselProps {
  centerVertically?: boolean
  children: JSX.Element[] | JSX.Element
  className?: string
  hideScrollbars?: boolean
}
// TODO: consume a 3rd party carousel here https://linear.app/withpower/issue/POW-2012/[home-page]-the-card-is-cut-off-before-the-side-of-the-page-on-desktop
export const Carousel = ({
  centerVertically = true,
  children,
  className,
  hideScrollbars,
}: CarouselProps) => {
  return (
    <div
      className={classMerge(
        'relative',
        'w-full',
        'overflow-x-auto',
        'overflow-y-visible',
        'flex',
        'flex-row',
        'pb-2',
        centerVertically && 'items-center',
        className,
        hideScrollbars && 'hide-scrollbars',
      )}
    >
      {children}
    </div>
  )
}

export const CAROUSEL_CARD_STYLES = 'min-w-[80%] md:min-w-[28%]'

const CarouselSimple = ({ children }: CarouselProps) => (
  <Carousel>{children}</Carousel>
)

Carousel.Simple = CarouselSimple
